import api from '../helpers';

export default {
  get: {
    key: 'fetchEnergy',
    query: (companyId) => {
      return api.get(`/api/energy/${companyId}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
    mapper: ({ data }) => {
      return data;
    },
  },
  create: {
    key: 'addEnergy',
    query: (data) => {
      return api.post('/api/energy', {
        headers: {
          'Content-Type': 'application/json',
        },
        data,
        _throwError: true,
      });
    },
  },
  editUtilProvider: {
    key: 'editUtilProvider',
    query: (id, data) => {
      return api.put(`/api/energy/${id}/utilprovider`, {
        headers: {
          'Content-Type': 'application/json',
        },
        data,
        _throwError: true,
      });
    },
  },
  editFixedEfficiency: {
    key: 'editUtilProvider',
    query: (id, data) => {
      return api.put(`/api/energy/${id}/fixedefficiency`, {
        headers: {
          'Content-Type': 'application/json',
        },
        data,
        _throwError: true,
      });
    },
  },
  editGasCost: {
    key: 'editGasCost',
    query: (id, data) => {
      return api.put(`/api/energy/${id}/gascost`, {
        headers: {
          'Content-Type': 'application/json',
        },
        data,
        _throwError: true,
      });
    },
  },
};
